<template>
  <div :class="['box', isModal ? 'box_modal' : '']">
    <div :class="['left', (goodsInfo.fitUser === 2 || goodsInfo.fitUser === 3) ? 'left2' : '']">
      <div class="left_text1" v-if="goodsInfo.discountType === 1">
        <span>￥</span>
        {{ goodsInfo.discountAmount }}
      </div>
      <div class="left_text1" v-else>{{ goodsInfo.discountAmount }}折</div>
      <div class="left_text2">满{{ goodsInfo.usableCondition }}可用</div>
      <div class="left_text3" v-if="goodsInfo.fitUser === 2 || goodsInfo.fitUser === 3">{{ goodsInfo.fitUser === 2 ?
        '新用户专享' : (goodsInfo.fitUser === 3 ? '老用户专享' : '') }}</div>
    </div>
    <div :class="['right', isModal ? 'right_modal' : '']">
      <div class="right_text1">{{ goodsInfo.frontEndName }}</div>
      <div class="right_text2">{{ showType(goodsInfo.productionFitType,goodsInfo.packageFitType) }}</div>
      <div v-if="goodsInfo.effectiveTimeType === 2" class="right_text3">有效期至: {{ Format2(goodsInfo.effectiveTimeBegin)
        }}-{{ Format2(goodsInfo.effectiveTimeEnd) }}</div>
      <div v-if="goodsInfo.effectiveTimeType === 1" class="right_text3">领取后{{ goodsInfo.effectiveDays }}天内有效</div>
      <div v-if="goodsInfo.effectiveTimeType === 3" class="right_text3">领取后当天有效</div>
      <div v-if="goodsInfo.effectiveTimeType === 4" class="right_text3">领取后{{ goodsInfo.effectiveHours }}小时内有效</div>
    </div>
  </div>
</template>

<script>
import { dateTime, replaceHyphens } from '@/utils/tools';

export default {
  props: {
    goodsInfo: {
      type: Object,
      default: () => { },
    },
    isModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    Format2(date) {
      const dateTimes = dateTime(new Date(replaceHyphens(date)).getTime());
      return `${dateTimes.year}.${dateTimes.month}.${dateTimes.day}`;
    },
    showType(type, status) {
      const typeMap = {
        1: '所有产品',
        2: '指定产品可用',
        3: '指定产品可用',
      };
      let text = typeMap[type] || '';
      if (status === 4) {
        text = type === 1 ? '所有产品' : '指定产品可用';
      } else if (status === 5) {
        text = '指定产品可用';
      }
      return text;
    },
  },
};
</script>

<style scoped lang='scss'>
.box {
  width: 678px;
  height: 163px;
  margin-bottom: 18px;
  background: linear-gradient(180deg, #fff1cd 0%, #ffe6b3 100%);
  border-radius: 14px;

  .left {
    float: left;
    height: 83px;
    margin-top: 40px;
    // width: 116px;
    margin-left: 36px;

    .left_text1 {
      height: 49px;
      color: #894e0f;
      font-weight: normal;
      font-size: 43px;
      font-family: Arial, sans-serif;
      line-height: 49px;
      text-align: center;

      span {
        height: 29px;
        color: #894e0f;
        font-weight: normal;
        font-size: 25px;
        font-family: Arial, sans-serif;
        line-height: 29px;
      }
    }

    .left_text2 {
      height: 31px;
      margin-top: 4px;
      color: #894e0f;
      font-weight: 400;
      font-size: 22px;
      font-family: PingFangSC, sans-serif;
      line-height: 31px;
    }

    .left_text3 {
      height: 29px;
      margin-top: 7px;
      color: #b58654;
      font-weight: 400;
      font-size: 18px;
      font-family: PingFangSC, sans-serif;
      line-height: 29px;
      border: 1px solid #b58654;
      border-radius: 5px;
    }
  }

  .left2 {
    margin-top: 20px;
  }

  .right {
    float: right;
    width: 478px;
    height: 145px;
    margin-top: 9px;
    margin-right: 9px;
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/conpou_bkg.png') no-repeat;
    background-size: 100% 100%;

    .right_text1 {
      height: 36px;
      margin-top: 22px;
      margin-left: 22px;
      overflow: hidden;
      color: #333;
      font-weight: 500;
      font-size: 25px;
      font-family: PingFangSC, sans-serif;
      line-height: 36px;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .right_text2 {
      height: 29px;
      margin-top: 7px;
      margin-left: 22px;
      overflow: hidden;
      color: #999;
      font-weight: 400;
      font-size: 22px;
      font-family: PingFangSC, sans-serif;
      line-height: 29px;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .right_text3 {
      height: 33px;
      margin-top: 7px;
      margin-left: 22px;
      overflow: hidden;
      color: #999;
      font-weight: 400;
      font-size: 18px;
      font-family: PingFangSC, sans-serif;
      line-height: 29px;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .right_modal {
    width: 357px;
  }
}

.box_modal {
  width: 543px;
}
</style>
